import Cookies from 'js-cookie';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { AUTH_COOKIE_NAME } from '@constants';

export const useGetImpersonationToken = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Synchronous set: useIsAuth reads the cookie during render, before effects run.
  const token = new URLSearchParams(window.location.search).get('token');
  if (token) {
    Cookies.set(AUTH_COOKIE_NAME, token);
  }

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('token')) {
      params.delete('token');
      const search = params.toString();
      navigate(`${location.pathname}${search ? `?${search}` : ''}`, { replace: true });
    }
  }, [location, navigate]);
};
